import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { confirmPasswordReset } from "firebase/auth";
import { auth } from "../../firebase";
import bcrypt from "bcryptjs";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("Enter your new password");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  let email = searchParams.get("email");
const continueUrl = searchParams.get("continueUrl");
const oobCode = searchParams.get("oobCode");

if (!email && continueUrl) {
  try {
    const parsed = new URL(continueUrl);
    email = parsed.searchParams.get("email");
  } catch (err) {
    console.warn("❌ Could not parse continueUrl");
  }
}


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!oobCode || !email) return setStatus("❌ Invalid reset link.");

    try {
      await confirmPasswordReset(auth, oobCode, password);
      const hashed = await bcrypt.hash(password, 10);

      // 🔁 Call backend to sync with Firestore
      const res = await fetch(`${BACKEND_URL}/auth/update-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, newPassword: hashed }),
      });

      const data = await res.json();
      if (!res.ok) {
        console.warn("⚠️ Firestore update failed:", data.message);
      } else {
        console.log("✅ Firestore password updated:", data.message);
      }

      setStatus("✅ Password reset successful!");
      setSubmitted(true);
      setTimeout(() => navigate("/login"), 3000);
    } catch (err) {
      console.error("❌ Reset failed:", err);
      setStatus("❌ Invalid or expired reset link.");
    }
  };

  return (
    <div style={{ padding: "60px", textAlign: "center" }}>
      <h2>{status}</h2>
      {!submitted && (
        <form onSubmit={handleSubmit} style={{ maxWidth: "400px", margin: "auto", marginTop: "30px" }}>
          <input
            type="password"
            placeholder="New Password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ padding: "12px", width: "100%", marginBottom: "16px", borderRadius: "6px" }}
          />
          <button type="submit" style={{ padding: "10px 20px", borderRadius: "6px", backgroundColor: "#1570EF", color: "white", fontWeight: "bold" }}>
            Reset Password
          </button>
        </form>
      )}
      <p>You will be redirected shortly...</p>
    </div>
  );
};

export default ResetPassword;
